module.exports = __webpack_public_path__ + "static/media/arrow_right.25586966.svg";